import { computed } from 'vue';
import state from '../';

export const disabled = computed(() =>
    !state.loaded
    || state.editing_reference_sketches
    || state.editing_reference_partstudio
    || state.editing_reference_stl
    || state.rigid_move_manipulator
    || state.drawing_edge
    || state.carving
    || state.setting_symmetry_plane
    || state.setting_mirror_plane
    || state.selecting_tangent_perpendicular_plane
    || state.currently_loading_model
    || uid_state.adding_edge_endpoints_status
    || uid_state.edge_first_vertex_added
    || state.offset_face_selecting_vertex
    || state.offset_face_dragging
);
